import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/node_modules/next/dist/client/app-dir/link.js");
